import { render, staticRenderFns } from "./statisticsPanel.vue?vue&type=template&id=1d73e2bc&scoped=true&"
import script from "./statisticsPanel.vue?vue&type=script&lang=js&"
export * from "./statisticsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d73e2bc",
  null
  
)

export default component.exports